import React from 'react';
import "./patner.css"
const Partners = ({ clients }) => {
  // Clone the first image and append it to the end of the list for smooth transition
  const extendedClients = [...clients, ...clients];

  return (
    <div id="clients" className="text-center mt-10 mb-11">
      <h1 className="text-3xl font-bold mb-10 text-tertary2 py-4">OUR CLIENTS</h1>
      <div className="overflow-hidden w-full">
         <div
          className="flex w-max animate-scroll gap-10"
          style={{ animation: 'scroll 30s linear infinite' }}
        >
          {extendedClients.map((client, index) => (
            <div key={index} className="relative">
              <img
                src={client}
                alt={`Client ${index}`}
                className="max-w-[200px] max-h-[95px] w-auto"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Partners;
